import React, {Component} from 'react';
import ReactSVG from 'react-svg';
import Button from './../../components/button/Button';
import { FormattedMessage } from 'react-intl';
import Dialog from '../../components/dialog/Dialog';
import AuthResources from './../../resourcers/authResources';

import BackArrow from './../../assets/img/back-icon.svg';
import TermsIcon from './../../assets/img/termsIcon.svg';
import AboutIcon from './../../assets/img/aboutIcon.svg';
import LogoutIcon from './../../assets/img/logoutIcon.svg';

import styles from './SettingsScreen.module.css';

class SettingsScreen extends Component {

    authResources = new AuthResources();

    constructor(props){
        super(props);
        this.dialogRef = React.createRef();
        this.state = {
            pageTransitionEnd: false
        }

        this.goBack = this.goBack.bind(this);
        this.logout = this.logout.bind(this);
        this.animationEnd = this.animationEnd.bind(this);
        this.goToAbout = this.goToAbout.bind(this);
        this.goToTermsConditions = this.goToTermsConditions.bind(this);
        this.openLogoutDialog = this.openLogoutDialog.bind(this);
    }

    goBack(){
        this.props.history.goBack();
    }

    goToTermsConditions(){
        this.props.history.push("/termsConditions");
    }

    goToAbout(){
        this.props.history.push("/about");
    }

    animationEnd() {
        this.setState({
            pageTransitionEnd: true
        });
    }

    openLogoutDialog() {
        if(this.dialogRef.current){
            this.dialogRef.current.open();
        }
    }

    logout() {
        this.authResources.clear();
        this.props.history.replace('/');
    }

    render(){
        let animation = "";
        if(!this.state.pageTransitionEnd){
            animation = " animated slideInUp";
        }

        return (
            <div>
                <Dialog
                    title={<FormattedMessage id="confirmQuit" />}
                    description={<FormattedMessage id="confirmQuitText" />}
                    cancelText={<FormattedMessage id="cancel" />}
                    confirmText={<FormattedMessage id="ok" />}
                    ref={this.dialogRef}
                    confirm={this.logout}
                />
                <div className={animation} onAnimationEnd={this.animationEnd}>
                    <ReactSVG onClick={this.goBack} src={BackArrow} className={styles.backButton} />
                    <div className={styles.topBar}>
                        <h1><FormattedMessage id="settings" /></h1>
                    </div>
                    <div className={styles.option1} onClick={this.goToTermsConditions}>
                        <ReactSVG src={TermsIcon} />
                        <p><FormattedMessage id="termsAndConditions"/></p>
                    </div>
                    <div className={styles.option2} onClick={this.goToAbout}>
                        <ReactSVG src={AboutIcon} />
                        <p><FormattedMessage id="about"/></p>
                    </div>
                    <div className={styles.option3} onClick={this.openLogoutDialog}>
                        <ReactSVG src={LogoutIcon} />
                        <p><FormattedMessage id="logout"/></p>
                    </div>
                </div>
            </div>
        );
    }

}

export default SettingsScreen;